import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-popup',
  templateUrl: './popup.component.html',
  styleUrls: ['./popup.component.css']
})
export class PopupComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

  navigate(){
    window.open('https://my.subscrybe.app/dashboard')
  }
  
  feedback(){
    window.open('https://forms.gle/hWsKVRqxy5e8UgYb6')
  }

}
